export default ({ id, created, updated, ...data } = {}, spaces = "") =>
  JSON.stringify({ id, ...data, created, updated }, null, 2)
    .split("\n")
    .map(row => `${spaces}${row}`)
    .join("\n");
